import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { bonuses, included, volumes } from '../data/offer';
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-127" data-mp="1870ybwgqtxsm">
        <div className="mx-auto max-w-5xl" data-id="element-128" data-mp="1d6ndwck1nq4l">
          <header className="text-center" data-id="element-129" data-mp="1d5c86771g8au">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-130" data-mp="yi0yybybx0dw">
              🏆 SISTEMA INFORMACIÓN BAJO CONTROL™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium sm:text-xl" data-id="element-131" data-mp="13aai994xv277">
              Tu método en 3 volúmenes para organizar y gestionar la información sobre la epilepsia de tu hijo sin saturarte.
            </p>
            <p className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-slate-400" data-id="element-132" data-mp="ueb8fgy3g8q8">
              Contenido educativo y organizativo. Complementa el seguimiento médico; no lo
              reemplaza.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-133" data-mp="3let3q113trvk">📚 3 VOLÚMENES</h3>
          </header>
          <div className="mt-7 space-y-5" data-id="element-134" data-mp="3gg8d8tbnmmkb">
            {volumes.map((volume, index) => <motion.article key={volume.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex gap-5 rounded-2xl border ${volume.border} bg-brand-ink p-5 sm:p-7`} data-id="element-135" data-mp="3gicfz7xthfj0" data-mpi={index}>
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-136" data-mp="3bh5715jxuaar" />
                <div data-id="element-137" data-mp="36px1wlpn5b3e">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-138" data-mp="36olwyikglxap">{volume.title}</h4>
                  <ul className="mt-4 space-y-2" data-id="element-139" data-mp="2iz9mlfdebj6t">
                    {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-140" data-mp="2ezshin1vso26">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-141" data-mp="hxlas3rcbz6j" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-142" data-mp="wmzkjcytwimg">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-143" data-mp="3v54xqdhhne9q">El Sistema incluye:</h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-144" data-mp="3ybu72z83321">
              {included.map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-145" data-mp="8xoh1nq3ga4m">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-146" data-mp="8wdd9nwnf2di" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-147" data-mp="1kexzc6xhkw4c">
        <div className="mx-auto max-w-5xl" data-id="element-148" data-mp="1pavggfgkq6i6">
          <header className="text-center" data-id="element-149" data-mp="1pe12fltwos9o">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-150" data-mp="39u8pqdrkhuyq" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-151" data-mp="34uckycb1pzi4">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[.18em]" data-id="element-152" data-mp="302bbsz96cowb">SIEMPRE INCLUIDOS</p>
          </header>
          <div className="mt-10 space-y-4" data-id="element-153" data-mp="2v4t1b4fie1m7">
            {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-154" data-mp="2q7188734o9gf">
                <span className="w-fit whitespace-nowrap rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-155" data-mp="2h51r7es455dh">
                  BONO {bonus.number}
                </span>
                <div className="flex-1" data-id="element-156" data-mp="2c8jqcpzwlr6f">
                  <h3 className="font-bold" data-id="element-157" data-mp="fe6py7f50dzd">{bonus.title}</h3>
                  <ul className="mt-3 space-y-2" data-id="element-158" data-mp="aeu67vjkbn10">
                    {bonus.details.map(detail => <li key={detail} className="flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-159" data-mp="acr6gjslyfj3">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-160" data-mp="344pfeweebc1f" />
                        {detail}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-161" data-mp="2z7qmuiadrd5c">
                  <span className="text-sm text-slate-500 line-through" data-id="element-162" data-mp="2z5w3v9io5v3w">{bonus.value}</span>
                  <span className="whitespace-nowrap rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-163" data-mp="2kh9r9fkffhgd">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-164" data-mp="2gh8zyuc8bbrw">
            <p className="text-xs font-bold tracking-[.17em] text-brand-gold" data-id="element-165" data-mp="21k8hzijuav6m">VALOR TOTAL BONOS</p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-166" data-mp="26is69plwoj25">$52.000</p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-167" data-mp="1mx9u1xk6yiwn">
              GRATIS con tu Sistema Información Bajo Control™
            </p>
          </div>
        </div>
      </section>
    </>;
}